<!-- =========================================================================================
  File Name: CustomersABC.vue
  Description: Customers ABC statistic
  ----------------------------------------------------------------------------------------
  Item Name: C4 - User list for management
  Author: Oscar Ramírez O.
  Author URL: https://acentoNET.com
========================================================================================== -->

<template>
  <div>
<!--    <add-new-data-sidebar :isSidebarActive="addNewDataSidebar" :id="editID" @closeSidebar="addNewDataSidebar = false"/>-->
    <div class="vx-col w-full mb-base">
      <vx-card ref="parametersCard" class="mb-2">
        <div class="flex justify-start inline-block align-middle">
          <div class="mr-2" style="min-width: 495px;">
            <ejs-daterangepicker ref="period" :startDate="startDate" :endDate="endDate" floatLabelType="Auto" placeholder="Seleccione período"/>
          </div>
          <div>
            <vs-button radius color="success" type="filled" icon-pack="feather" icon="icon-search" class="ml-4 mt-2" @click="getReport"/>
          </div>
        </div>
      </vx-card>
      <vx-card ref="reportCard" class="mb-2" v-show="gridReady">
        <ejs-grid
          ref="grid"
          :dataSource="data"
          locale='es-GT'
          :toolbar='toolbarOptions'
          :allowSorting='true'
          :sortSettings='sortOptions'
          :allowExcelExport='true'
          :toolbarClick='toolbarClick'
        >
          <e-columns>
            <e-column field="customerId" :visible=false headerText="ID" :isPrimaryKey="true"/>
            <e-column field="customerName" headerText="Cliente" clipMode='EllipsisWithTooltip' :filter='checkBoxFilter'/>
            <e-column field="amount" type="number" headerText="Valor" textAlign='Right' format="N2" width="150"/>
          </e-columns>
          <e-aggregates>
            <e-aggregate>
              <e-columns>
                <e-column type="Sum" field="amount" format="N2"/>
              </e-columns>
            </e-aggregate>
          </e-aggregates>
        </ejs-grid>
      </vx-card>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue';
  import * as lang from 'vuejs-datepicker/src/locale';

  import {loadCldr, L10n, setCulture} from '@syncfusion/ej2-base';
  import {GridPlugin, Toolbar, Search, Page, Sort, ExcelExport, Aggregate, Filter} from '@syncfusion/ej2-vue-grids';
  import {DateRangePickerPlugin} from '@syncfusion/ej2-vue-calendars';
  import numberingSystems from 'cldr-data/supplemental/numberingSystems.json';
  import gregorian from 'cldr-data/main/es-GT/ca-gregorian.json';
  import numbers from 'cldr-data/main/es-GT/numbers.json';
  import timeZoneNames from 'cldr-data/main/es-GT/timeZoneNames.json';
  import weekData from 'cldr-data/supplemental/weekData.json';// To load the culture based first day of week

  Vue.use(DateRangePickerPlugin);
  Vue.use(GridPlugin);

  loadCldr(numberingSystems, gregorian, numbers, timeZoneNames, weekData);
  setCulture('es-GT');
  L10n.load({
    'es-GT': {
      'daterangepicker': {
        placeholder: 'Seleccione período',
        startLabel: 'Fecha inicial',
        endLabel: 'Fecha final',
        applyText: 'Seleccionar',
        cancelText: 'Cancelar',
        selectedDays: 'Seleccione día inicial y final',
        days: 'Días'
      },
      'grid': {
        'EmptyRecord': 'No se encontraron transacciones de venta',
        'Search': 'Buscar',
        'Excelexport': 'Exportar'
      },
      'pager': {
        'currentPageInfo': '{0} de {1} páginas',
        'firstPageTooltip': 'Ir a primera página',
        'lastPageTooltip': 'Ir a última página',
        'nextPageTooltip': 'Ir a página siguiente',
        'previousPageTooltip': 'Ir a página anterior'
      }
    }
  });

  export default {
    data() {
      return {
        loaded: false,
        gridReady: false,
        language: lang,
        startDate: null,
        endDate: null,
        data: [],
        editID: null,
        addNewDataSidebar: false,
        dateFormatOptions: {type: 'dateTime', format: 'dd/MM/yyyy hh:mm a'},
        pageSettings: {pageSize: 100},
        toolbarOptions: ['Search', 'ExcelExport'],
        sortOptions: {columns: [{field: 'amount', direction: 'Descending'}]},
        filterOptions: {
          type: 'Menu'
        },
        checkBoxFilter: {
          type: 'CheckBox'
        },
        cardTitle: 'ABC de Clientes'
      }
    },
    provide: {
      grid: [Toolbar, Search, Page, Sort, ExcelExport, Aggregate, Filter]
    },
    computed: {
      api() {
        return this.$store.getters.getParameter('connection').apiURL;
      }
    },
    methods: {
      numericFormat(value, decimals) {
        var ret = value;
        if (typeof value !== 'undefined') {
          ret = value.toFixed(decimals).replace(/\d(?=(\d{3})+\.)/g, '$&,');
        }
        return ret;
      },
      discountFormatter(field, data) {
        return (data[field] == 0 ? '' : data[field].toFixed(2));
      },
      dateFormat(value) {
        var d = new Date(value);
        return `${d.getDate().toString().padStart(2, '0')}/${d.getMonth().toString().padStart(2, '0')}/${d.getFullYear()} ${d.getHours().toString().padStart(2, '0')}:${d.getMinutes().toString().padStart(2, '0')}:${d.getSeconds().toString().padStart(2, '0')}`;
      },
      dateISOFormat(value) {
        const d = new Date(value.getTime() - (6 * 60 * 60 * 1000));
        return d.toISOString();
      },
      formatDate: function (field, data) {
        var d = new Date(data[field].replace('Z', ''));
        return d.toLocaleString();
        // return `${d.getDate().toString().padStart(2, '0')}/${d.getMonth().toString().padStart(2, '0')}/${d.getFullYear()} ${d.getHours().toString().padStart(2, '0')}:${d.getMinutes().toString().padStart(2, '0')}:${d.getSeconds().toString().padStart(2, '0')}`;
      },
      toolbarClick: function (args) {
        if (args.item.id.includes('excelexport')) { // 'Grid_excelexport' -> Grid component id + _ + toolbar item name
          let excelExportProperties = {
            fileName: "ABCClientes.xlsx"
          };
          this.$refs.grid.excelExport(excelExportProperties);
        }
      },
      getReport() {
        this.startDate = this.$refs.period.getSelectedRange().startDate;
        this.endDate = this.$refs.period.getSelectedRange().endDate;
        if (this.startDate) {
          if (this.endDate) {
            this.startDate.setHours(0);
            this.startDate.setMinutes(0);
            this.startDate.setSeconds(0);
            this.endDate.setHours(23);
            this.endDate.setMinutes(59);
            this.endDate.setSeconds(59);
            if (this.startDate < this.endDate) {
              this.cardTitle = 'ABC de clientes del ' + this.startDate.toLocaleDateString() + ' al ' + this.endDate.toLocaleDateString();
              this.$vs.loading({
                text: 'Cargando consulta',
                type: 'point'
              });
              var self = this;
              var data = {
                startDate: this.dateISOFormat(this.startDate),
                endDate: this.dateISOFormat(this.endDate),
                userId: this.$store.state.AppActiveUser.userId,
                token: this.$store.state.AppActiveUser.token
              };
              this.$http.post(`${this.api}/statistics/sales/customer_abc`, data).then(response => {
                if (response.data.success) {
                  if (response.data.data) {
                    self.data = response.data.data
                  } else {
                    self.data = [];
                  }
                  self.gridReady = true;
                } else {
                  self.$vs.notify({
                    title: 'Error al cargar ABC de clientes',
                    text: response.data.message,
                    color: 'danger'
                  });
                }
                this.$vs.loading.close();
                self.loaded = true;
              }).catch(error => {
                self.loaded = true;
                this.$vs.loading.close();
                var errorMessage = '';
                if (error.response) {
                  errorMessage = error.response.data.ErrorMessage
                } else {
                  errorMessage = 'Error de conectividad'
                }
                self.$vs.notify({
                  title: 'Error al cargar ABC de clientes',
                  text: errorMessage,
                  color: 'danger'
                });
              });
            } else {
              this.$vs.notify({
                title: 'Error en parámetros',
                text: 'Fecha final debe ser mayor a fecha inicial',
                color: 'danger'
              });
            }
          } else {
            this.$vs.notify({
              title: 'Error en parámetros',
              text: 'Debe especificar una fecha de finalización',
              color: 'danger'
            });
          }
        } else {
          this.$vs.notify({
            title: 'Error en parámetros',
            text: 'Debe especificar una fecha de inicio',
            color: 'danger'
          });
        }
      },
      refreshData(card) {
        this.getReport();
        if (typeof card !== 'undefined') {
          card.removeRefreshAnimation(500);
        }
      }
    },
    mounted() {
      this.startDate = new Date();
      this.startDate.setHours(0);
      this.startDate.setMinutes(0);
      this.startDate.setSeconds(0);
      this.startDate.setDate(1)
      this.endDate = new Date();
      this.endDate.setHours(23);
      this.endDate.setMinutes(59);
      this.endDate.setSeconds(59);
    }
  }
</script>

<style lang="scss">
  @import '../../../../node_modules/@syncfusion/ej2-base/styles/material.css';
  @import '../../../../node_modules/@syncfusion/ej2-buttons/styles/material.css';
  @import '../../../../node_modules/@syncfusion/ej2-inputs/styles/material.css';
  @import '../../../../node_modules/@syncfusion/ej2-popups/styles/material.css';
  @import '../../../../node_modules/@syncfusion/ej2-navigations/styles/material.css';
  @import '../../../../node_modules/@syncfusion/ej2-lists/styles/material.css';
  @import "../../../../node_modules/@syncfusion/ej2-vue-calendars/styles/material.css";
  @import "../../../../node_modules/@syncfusion/ej2-vue-grids/styles/material.css";
</style>
